import Bronze from 'bronze';
import { cloneDeep, sortBy } from 'lodash-es';
import makeDisplay from './makeDisplay';

const id = new Bronze();

export default function(table, sortOrder) {
	return new Promise(resolve => {
		const build = cloneDeep(table);
		let headers = [];
		let rows = [];
		let columns;

		let picklists = build.schema.columns.map(col => {
			if (!col.picklistKey) return null;
			let picklist = build.picklists.find(list => list.picklistKey === col.picklistKey);
			col._picklist = picklist;
			return picklist;
		});

		if (sortOrder) {
			sortOrder.forEach(sort => {
				build.data.data.sort((a, b) => {
					let aVal = a[sort].key ? a[sort].key.join(' ') : a[sort].value;
					let bVal = b[sort].key ? b[sort].key.join(' ') : b[sort].value;
					return aVal.localeCompare(bVal);
				});
			});
		}

		build.data.data.forEach(_row => {
			let rowId = id.generate();
			_row = _row.map((_cell, i) => {
				_cell._id = id.generate();
				_cell._row = rowId;
				_cell._column = build.data.columnEnumeration[i];
				_cell._regex = build.schema.columns[i].filterableTextRegExPattern;
				_cell._filterable = build.schema.columns[i].filterable;
				_cell._editorType = build.schema.columns[i].editorType;
				_cell._display = makeDisplay(_cell, picklists[i]);
				return _cell;
			});
			rows.push([rowId, _row]);
		});
		rows = Object.fromEntries(rows);

		columns = build.data.data[0].map((col, i) => build.data.data.map(row => row[i]));

		headers = build.schema.columns.map((item, i) => {
			item._id = item.columnKey;
			item._display = item.columnName;
			item._filters = [];
			let tags = [...new Set(columns[i].map(item => item._filterTag))].sort();
			tags.forEach(tag => {
				let filter = {};
				filter.tag = tag;
				filter.values = [...new Set(columns[i].filter(item => item._filterTag === tag))].map(
					item => item._row
				);
				item._filters.push(filter);
			});
			return item;
		});

		resolve({ headers, rows });
	});
}
